import { useFormikContext } from 'formik';
import { ParentCustomer } from 'lib/api/multiLocations/multiLocationQuery';
import React from 'react';
import { LocationItem } from './LocationItem';
interface IProps {
  openModalHandler: (name: string | null, locationId: number | null) => void;
}
export const EditLocationView = ({ openModalHandler }: IProps) => {
  const { values } = useFormikContext<ParentCustomer>();
  return (
    <>
      {values.business && (
        <LocationItem
          customerId={values.customerId}
          label={values.location.name}
          openModalHandler={() => {
            if (values.location.locationId) {
              openModalHandler(
                values.location.name,
                values.location.locationId
              );
            }
          }}
        />
      )}
      {values.childCustomers.map((childCustomer, index) => {
        const { name, locationId, customerId } = childCustomer.location;
        return (
          <LocationItem
            customerId={customerId}
            key={index}
            label={name}
            openModalHandler={() => {
              if (locationId) {
                openModalHandler(name, locationId);
              }
            }}
          />
        );
      })}
    </>
  );
};
